<template>
  <IQOS required enabled :title="$t('worker_profile.modes_title')">
    <IQOSModeToggle
      class="mt-16"
      :value="waiter.attached_modes.inside"
      @input="toggleMode('inside')"
      mode="inside"
      noColor
      v-if="cafe.modes.inside"/>
     <IQOSModeToggle
      :value="waiter.attached_modes.delivery"
      class="mt-8"
      mode="delivery"
      noColor
      @input="toggleMode('delivery')"
      v-if="cafe.modes.delivery"/>
    <IQOSModeToggle
      :value="waiter.attached_modes.preorder"
      @input="toggleMode('preorder')"
      class="mt-8"
      noColor
      mode="preorder"
      v-if="cafe.modes.preorder"/>
     <IQOSModeToggle
      :value="waiter.attached_modes.reserve"
      class="mt-8"
      noColor
      @input="toggleMode('reserve')"
      mode="reserve"
      v-if="cafe.modes.reserve"/>
    <IQOSModeToggle
      :value="waiter.attached_modes.hotels"
      class="mt-8"
      noColor
      @input="toggleMode('hotels')"
      mode="hotels"
      v-if="cafe.modes.hotels"/>

    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("worker_profile.modes_comment") }}
    </p>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";
import SlideToggle from "@/components/SlideToggle.vue";
import SlideToggleRow from "@/components/SlideToggleRow.vue";

export default {
  data() {
    return {};
  },
  props: {
    waiter: Object,
  },
  methods: {
    toggleMode(m) {
      this.$emit("toggle", m);
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
  },
  components: {
    IQOS,
    RoundCheckbox,
    SlideToggle,
    SlideToggleRow,
  },
};
</script>

<style scoped>
</style>
